import Environment from '../../Environment';
import stages from '../stages';
import MockSplit from '../../MockSplit';

const prod = new Environment({
    name: stages.PRODUCTION,
    evaluationFn: (_attributes) => {
        return 'on';
    },
});

const demo = new Environment({
    name: stages.DEMO,
    evaluationFn: (_attributes) => {
        return 'on';
    },
});

const staging = new Environment({
    name: stages.STAGING,
    evaluationFn: (_attributes) => {
        return 'on';
    },
});

const local = new Environment({
    name: stages.LOCAL,
    evaluationFn: (_attributes) => {
        return 'on';
    },
});

const dev = new Environment({
    name: stages.DEV,
    evaluationFn: (_attributes) => {
        return 'on';
    },
});

const can_use_bay_scheduling = new MockSplit({
    name: 'can_use_bay_scheduling',
    environments: [local, dev, staging, demo, prod],
});

export default can_use_bay_scheduling;
